import type { CustomFlowbiteTheme } from 'flowbite-react';

export const textInputTheme: CustomFlowbiteTheme['textInput'] = {
  base: 'flex',
  addon:
    'inline-flex items-center rounded-l-md border border-r-0 border-titan-night-300 bg-titan-night-200 px-3 text-sm text-titan-night-900',
  field: {
    base: 'relative w-full',
    icon: {
      base: 'pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3',
      svg: 'h-5 w-5 text-titan-night-500',
    },
    rightIcon: {
      base: 'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3',
      svg: 'h-5 w-5 text-titan-night-500',
    },
    input: {
      base: 'block w-full border disabled:cursor-not-allowed disabled:opacity-50',
      sizes: {
        sm: 'p-2 sm:text-xs',
        md: 'p-2.5 text-sm',
        lg: 'sm:text-md p-4',
      },
      colors: {
        gray: 'bg-white border-titan-night-300 text-titan-night-900',
        info: 'border-titan-blue-500 bg-titan-blue-50 text-titan-blue-900 placeholder-titan-blue-700',
        failure:
          'border-titan-folly-500 bg-titan-folly-50 text-titan-folly-900 placeholder-titan-folly-700 focus:border-titan-folly-500 focus:ring-titan-folly-500',
        warning:
          'border-titan-yellow-500 bg-titan-yellow-50 text-titan-yellow-900 placeholder-titan-yellow-700 focus:border-titan-yellow-500 focus:ring-titan-yellow-500',
        success:
          'border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500',
      },
      withRightIcon: {
        on: 'pr-10',
        off: '',
      },
      withIcon: {
        on: 'pl-10',
        off: '',
      },
      withAddon: {
        on: 'rounded-r-lg',
        off: 'rounded-0',
      },
      withShadow: {
        on: 'shadow-sm',
        off: '',
      },
    },
  },
};
